import * as api from '../api'
import request from '../request'


// const getTeacherList = data => {
//   return request({
//     url : api.teacherList,
//     params : data
//   })
// }

const examineList = data => {
  return request({
    url : api.examineList,
    method : 'POST',
    data
  })
}

const examine = data => {
  return request({
    url : api.examine,
    method : 'POST',
    data
  })
}

const examineByOne = data => {
  return request({
    url : api.examineByOne,
    method : 'get',
    params : data
  })
}

const batchExamine = data => {
  return request({
    url : api.batchExamine,
    method : 'POST',
    data
  })
}
/**导出审核信息 */
const exportExamineFn = data => {
  return request({
    url: api.exportExamine,
    data
  })
}

const importStudentStatus = data => {
  return request({
    url: api.auditStudentImport,
    isUpload: true,
    data
  })
}

const examineNextFn = data => {
  return request({
    url: api.examineNextOne,
    data
  })
}
const backExamineFn = data => {
  return request({
    url: api.backExamine,
    data
  })
}

export default {
  examineList,
  examine,
  examineByOne,
  batchExamine,
  exportExamineFn,
  importStudentStatus,
  examineNextFn,
  backExamineFn,
} 